import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { AmsRewardsCsvComponent }      from './ams-rewards.csv.component';
import { AmsRewardsService }           from './ams-rewards.service';
import { AmsRewardsSettingsComponent } from './ams-rewards.settings.component';
import { AmsRewardsStates }            from './ams-rewards.states';
import { SharedModule }                from '../shared/shared.module';

@NgModule({
  declarations: [
    AmsRewardsCsvComponent,
    AmsRewardsSettingsComponent,
  ],
  entryComponents: [
    AmsRewardsCsvComponent,
    AmsRewardsSettingsComponent,
  ],
  imports: [
    SharedModule,

    UIRouterUpgradeModule.forChild({ states: AmsRewardsStates })
  ],
  providers: [
    AmsRewardsService
  ]
})
export class AmsRewardsModule {}
